import moment from 'moment';
import React, { useState, useEffect } from 'react';
import './style.scss';

const RealTimeClock = () => {
  const [currentTime, setCurrentTime] = useState(new Date());

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className='realtime'>
      <p>{moment(currentTime).format('D MMM, YYYY  |  h:mm a')}</p>
    </div>
  );
};

export default RealTimeClock;
